export default __webpack_public_path__ + "static/media/CustomerStatementReport.ba4c517e.svg";